import styled, { keyframes } from 'styled-components';
import { ReactComponent as Logo } from '../../../../../assets/logo.svg';

const viewDescription = keyframes`
	from {
    transform: translateY(100%);
  }
  to {
    transform: translateY(0);
  }
`;

export const Wrapper = styled.article`
    display: flex;
    z-index: 1;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    padding: 0 20px;
    margin-bottom: 50px;
    max-width: 1000px;
    animation: ${viewDescription} 1.5s ease-in-out;
    @media screen and (max-width: 999px) {
        max-width: 690px;
    }
    @media screen and (max-width: 576px) {
        /* align-items: center; */
    }
`;

export const BigYellowText = styled.h2`
    font-size: 24px;
    line-height: 30px;
    color: #ffd467;
    font-weight: 400;
    text-align: justify;
    margin-top: 8px;

    @media screen and (max-width: 576px) {
        text-align: center;
    }

    & a {
        text-decoration: underline;
        cursor: pointer;
    }
`;

export const LogoBox = styled.div`
    margin: 32px 0 27px;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: baseline;
    & h1 {
        font-weight: 400;
        font-size: 26px;
        line-height: 30px;
        text-align: center;
        color: #ffffff;
    }
    @media screen and (max-width: 576px) {
        margin: 18px 0 30px;
        flex-direction: column;
        align-items: center;
    }
`;

export const Logotype = styled(Logo)`
    @media screen and (min-width: 577px) {
        margin-left: 10px;
    }
`;

export const Text = styled.div`
    font-weight: 400;
    font-size: 20px;
    line-height: 22px;
    color: #ffffff;
    margin-bottom: 32px;
    & a {
        color: #ffffff;
        text-decoration: underline;
    }
    @media screen and (max-width: 576px) {
        font-size: 16px;
    }
`;
export const YellowText = styled(Text)`
    color: #ffd467;
`;
export const GreyText = styled(Text)`
    font-style: italic;
    font-weight: 400;
    font-size: 15px;
    line-height: 18px;
    color: #759b9d;
`;

export const DeviceWrapper = styled.div`
    display: flex;
    justify-content: space-evenly;
    flex-wrap: wrap;
    & > a {
        margin-right: 32px;
        display: block;
        text-decoration: none;
        cursor: pointer;
    }
    & > a:last-child {
        margin-right: 0px;
    }
`;
